const { produce } = require("immer");

const init = {
  uid: null,
  projectUid: null,
  name: null,
  rights: []
}

module.exports = function (state = init, action) {
  switch(action.type) {
    case "SET_roleForm":
      return produce(state, draft => {
        Object.assign(draft, init, action.form);
      });

    case "UPDATE_roleForm":
      return produce(state, draft => {
        Object.assign(draft, action.form);
      });

    case "RESET_roleForm":
      return init;

    default:
      return state;
  }
}
